/* eslint-disable no-unused-vars */
import { Box, Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import account from '../services/account-service';

const PREFIX = 'RegistrationPage';
const classes = {
  root: `${PREFIX}-root`,
  form: `${PREFIX}-form`
};
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5'
  },
  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

export default function RegistrationPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigation = useNavigate();

  const handleRegistration = async () => {
    if (!firstName || !lastName || !email || !username || !password) {
      alert('Please fill in all fields!');
      return;
    }
    if (password !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }

    const response = await account.register({
      username,
      firstName,
      lastName,
      email,
      password,
      usertype: 2
    });
    console.log(response);
    if (response.success) {
      alert('Registration success');
      navigation('/');
    } else {
      alert(`Registration failed: ${response.reason}`);
    }
  };

  return (
    <Root className={classes.root}>
      <Box
        component="form"
        className={classes.form}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="first-name"
          label="First Name"
          variant="outlined"
          margin="normal"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <TextField
          id="last-name"
          label="Last Name"
          variant="outlined"
          margin="normal"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <TextField
          id="email"
          label="Email"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          id="username"
          label="Username/Email"
          variant="outlined"
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          id="password"
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          id="confirm-password"
          label="Confirm Password"
          type="password"
          variant="outlined"
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleRegistration}
        >
          Register
        </Button>
      </Box>
    </Root>
  );
}
